

export class RoutePathOutputWithOutStatus implements IRoutePathOutputWithOutStatus {
    /** The auto-generated id of the route path master */
    route_path_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: string;
    /** The auto-generated id of the branch details master */
    branch_detail_id!: string;
    /** The path name with 255 character limit */
    path_name!: string;
    /** The start point with 5000 character limit */
    start_point!: string;
    /** The start point with 5000 character limit */
    end_point!: string;
    /** The authorized halt tolerance should be 0 or 1 */
    authorized_halt_tolerance!: number;
    /** The description with 5000 character limit */
    description!: string;
    status!: number;

    constructor(data?: IRoutePathOutputWithOutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route_path_id = _data["route_path_id"];
            this.company_details_id = _data["company_details_id"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.path_name = _data["path_name"];
            this.start_point = _data["start_point"];
            this.end_point = _data["end_point"];
            this.authorized_halt_tolerance = _data["authorized_halt_tolerance"];
            this.description = _data["description"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RoutePathOutputWithOutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathOutputWithOutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route_path_id"] = this.route_path_id;
        data["company_details_id"] = this.company_details_id;
        data["branch_detail_id"] = this.branch_detail_id;
        data["path_name"] = this.path_name;
        data["start_point"] = this.start_point;
        data["end_point"] = this.end_point;
        data["authorized_halt_tolerance"] = this.authorized_halt_tolerance;
        data["description"] = this.description;
        data["status"] = this.status;
        return data; 
    }
}

export interface IRoutePathOutputWithOutStatus {
    /** The auto-generated id of the route path master */
    route_path_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: string;
    /** The auto-generated id of the branch details master */
    branch_detail_id: string;
    /** The path name with 255 character limit */
    path_name: string;
    /** The start point with 5000 character limit */
    start_point: string;
    /** The start point with 5000 character limit */
    end_point: string;
    /** The authorized halt tolerance should be 0 or 1 */
    authorized_halt_tolerance: number;
    /** The description with 5000 character limit */
    description: string;
    status: number;
}

